<template>
    <div class="main-con">
        <el-form ref="form" :model="form" :rules="companyRules" label-position="left" label-width="140px" class="reg-form" > 
            <h3 class="title">会员注册</h3> 
            <el-row :gutter="60"> 
                <el-col :span="12"> 
                    <el-form-item label="用户全称" prop="companyCn"> 
                        <el-input v-model.trim="form.companyCn"  placeholder="请输入" /> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="用户类型" prop="userType"> 
                        <el-select v-model="form.userType" placeholder="请选择" style="width: 100%"> 
                            <el-option
                                v-for="dict in userTypenOptions"
                                :key="dict.dictValue"
                                :label="dict.dictLabel"
                                :value="dict.dictValue"
                            ></el-option>
                        </el-select> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="统一社会信用代码" prop="job"> 
                        <el-input v-model.trim="form.job" placeholder="请输入" /> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="注册资本金(万元)" prop="regCapital"> 
                        <el-input-number v-model="form.regCapital" controls-position="right" :precision="4" :step="0.1" :min="0" placeholder="请输入" style="width: 100%"></el-input-number>
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="用户注册地" prop="compCode">
                        <el-cascader
                            style="width: 100%"
                            v-model="form.compCode"
                            :options="areaOptions">
                        </el-cascader>
                    </el-form-item> 
                </el-col>  
                <el-col :span="12"> 
                    <el-form-item label="法定代表人姓名" prop="legalPerson"> 
                        <el-input v-model.trim="form.legalPerson" placeholder="请输入" /> 
                    </el-form-item> 
                </el-col> 
                 <el-col :span="12"> 
                    <el-form-item label="联系人" prop="agencyPerson"> 
                        <el-input v-model.trim="form.agencyPerson" placeholder="请输入" /> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="用户地址详址" prop="compAddr"> 
                        <el-input v-model.trim="form.compAddr" placeholder="请输入" /> 
                    </el-form-item> 
                </el-col> 
                 <el-col :span="12"> 
                    <el-form-item label="联系人邮箱" prop="email"> 
                        <el-input v-model.trim="form.email" placeholder="请输入" /> 
                    </el-form-item> 
                </el-col>   
                <el-col :span="12"> 
                    <el-form-item label="联系人手机号" prop="mobile"> 
                        <el-input v-model.trim="form.mobile" :maxlength="11" placeholder="请输入" /> 
                    </el-form-item> 
                </el-col>  
                <el-col :span="12"> 
                    <el-form-item label="营业执照" prop="licenseFile"> 
                        <el-upload :on-success="(response,file) => handlePictureSuccess('licenseFile',response,file)" :before-upload="handleBeforeUpload" :on-error="handleUploadError" :limit="1" :headers="upload.headers" :action="upload.url" :on-remove="handleRemove"> 
                            <i class="el-icon-plus"></i> 
                        </el-upload> 
                    </el-form-item> 
                </el-col> 
                
                <el-col :span="24" style="padding: 20px 30px;"> 
                    <!-- 《调仲云链用户须知》、《调仲云链服务授权书》 -->
                    <el-checkbox v-model="checked"><a :href="`./file/调仲云链用户须知.pdf`" target="_blank">《调仲云链用户须知》</a>、<a :href="`./file/调仲云链服务授权书 .pdf`" target="_blank">《调仲云链服务授权书》</a></el-checkbox>
                </el-col>
            </el-row> 
            <el-row class="center"> 
                <el-button type="orange" class="reg-but" @click="handleLogin">
                    立即注册
                </el-button> 
            </el-row> 
        </el-form> 

    </div>
</template>
<script>
import area from '@/utils/area';
import baseUrl from '@/api/baseUrl.js' 
import { encrypt } from '@/utils/jsencrypt'

export default {
    data () {
        return {                
            // 表单校验
            companyRules:{
                companyCn: [
                        { required: true, message: "用户全称不能为空", trigger: "blur" }
                    ],
                userType:[
                    { required: true, message: "用户类型不能为空", trigger: "blur" }
                ],
                job: [
                    { required: true, message: "统一社会信用代码不能为空", trigger: "blur" }
                ],
                regCapital: [
                    { required: true, message: "注册资本金不能为空", trigger: "blur" }
                ],
                compCode: [
                        { required: true, message: "地址不能为空", trigger: "change" }
                    ], 
                legalPerson: [
                        { required: true, message: "法人代表姓名不能为空", trigger: "blur" }
                    ],
                 agencyPerson: [
                        { required: true, message: "联系人不能为空", trigger: "blur" }
                    ],
                compAddr: [
                        { required: true, message: "机构联系地址不能为空", trigger: "blur" }
                    ], 
                email:[
                    {
                    required: true,
                    pattern:  /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                    message: "请输入正确的邮箱",
                    trigger: "blur"
                    },
                ],
                mobile: [
                    { required: true, message: "联系人手机号不能为空", trigger: "blur"    },
                    {
                        pattern: /^1[0-9][0-9]\d{8}$/,
                        message: "请输入正确的手机号码",
                        trigger: "blur"
                    },   
                ],
                licenseFile: [
                    { required: true, message: "营业执照不能为空", trigger: "change" }
                ], 
            },            
            areaOptions:area,
            codemsg:'获取验证码',
            form: {
                companyType:'02',
                attrValues:[],
                licenseFile:'',
                fileAttach2:'',
                subject: this.$route.query.subject
            },
            loading: false,

            // 用户导入参数
            upload: {
                // 是否显示弹出层（用户导入）
                open: false,
                // 弹出层标题（用户导入）
                title: "",
                // 是否禁用上传
                isUploading: false,
                // 是否更新已经存在的用户数据
                updateSupport: 0,
                // 设置上传的请求头部
                // headers: { Authorization: "Bearer " + this.getToken() },
                // 上传的地址
                url: baseUrl.newucUrl + "/usercenter/user/uplodFile"
            },
            checked: false,
            subjectText: '',
            userTypenOptions: []
        };
    },
    mounted() {
        this.$api.api.getDicts("user_type").then(response => {
          this.userTypenOptions = response.data;
        }); 
        if(this.form.subject == 'zssj'){
            this.subjectText = '中数世纪'
        }else if(this.form.subject == 'qdyy'){
             this.subjectText = '青岛云毅'
        }
    },
    methods: { 
        handleLogin() { 	     	 
            this.$refs.form.validate(valid => {
                if (valid) {
                    if(this.checked){                        
                        this.form.attrValues.push({attrKey:'orgEmail',attrValue:this.form.orgEmail })
                        this.form.attrValues.push({attrKey:'compType',attrValue:this.form.compType })
                        if(this.form.compCode){
                            this.form.compProvinceCode = this.form.compCode[0]
                            this.form.compCityCode = this.form.compCode[1]
                            this.form.compDistrictCode = this.form.compCode[2]
                        }
                        
                        const loading = this.$loading({
                        lock: true,
                        text: '请稍后',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                        });

                        this.loading = true;
                        var formData = new FormData();
                        for(let i in this.form){
                            if(i == 'password'){
                                formData.append('password', encrypt(this.form.password))
                            }else if(i != 'attrValues'){
                                formData.append(i, this.form[i])
                            }

                        }

                        this.form.attrValues.map((item,i) =>{
                            formData.append(`attrValuesList[${i}].attrKey`, this.form.attrValues[i].attrKey)
                            formData.append(`attrValuesList[${i}].attrValue`, this.form.attrValues[i].attrValue)
                        })
                        
                        this.$api.api.registerOrganZCYL(formData).then(res => {
                            if (res.code == 200) {
                                this.loading = false;
                                this.$alert('您好，推荐码已发送到您填入的联系人手机上，请联系您的用户经理完成注册，谢谢！', '', {
                                    confirmButtonText: '确定',
                                    callback: action => {
                                        console.info(this.$route.query.backurl)
                                        if(this.$route.query.backurl){
                                            window.parent.location.href = this.$route.query.backurl
                                        }else {
                                            window.location.reload()
                                        }
                                    }
                                });
                            }else{
                                this.loading = false;
                                this.$message.error(res.msg)
                            } 

                            loading.close();	            
                        });
                    }else{
                        this.$message.warning("请先同意《用户服务协议》《存证服务授权书》！")
                    }

                }
            });
		},
        handleUploadError() {
            this.$message({
            type: "error",
            message: "上传失败",
            });
            this.loading.close();
        },
        handlePictureSuccess(key,file, fileList){
            this.$refs.form.clearValidate(key)
            this.form[key] = file.msg 
            this.form.attrValues.push({attrKey:key,attrValue:file.msg })
            this.loading.close();
        }, 
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handleBeforeUpload() {
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
        }
    }
};
</script>

<style lang="less">
@import '../assets/css/commen';
@import './style.less';
.reg-form{
    margin: 0 auto;
    width: 1100px;
    .title {
        text-align: center;
        margin: 30px auto 40px;
    }
    .center {
        text-align: center;
    }
    .reg-but{
        margin: 60px auto 30px;
        width: 200px;
        height: 40px;
    }
}
</style>